import styled from 'styled-components';

export const ContainerV2 = styled.div`
  width: 1080px;
  min-width: 425px;
  margin-bottom: 10px;
`;

export const HeadingV2 = styled.div`
  font-size: 18px;
  color: #444444;
  font-weight: 700;
  padding: 18px 14px 18px 14px;
  margin-left: 20px;
  align-self: center;
`;

export const HeaderContainerV2 = styled.div`
  background-color: #fff;
  border-right: 1px #e5e5e5 solid;
  border-top: 1px #e5e5e5 solid;
  border-left: 1px #e5e5e5 solid;
  border-radius: 6px 6px 0px 0px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const BodyV2 = styled.div`
  padding: 15px;
  height: 400px;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #dcdcdc;
  display: flex;
  flex-flow: column nowrap;
`;

export const BodyActionsV2 = styled.div`
  display: flex;
  align-self: end;
  margin-right: 60px;
`;

export const LoadingWrapperV2 = ({ isLoading, message, children, ...rest }) => {
  if (isLoading) {
    return (
      <LoadingSpinner>
        <i className="fa fa-circle-o-notch fast-spin fa-4x fa-fw" />
      </LoadingSpinner>
    );
  }

  if (message) {
    return <ChartMessage>{message}</ChartMessage>;
  }

  return <div {...rest}>{children}</div>;
};

const LoadingSpinner = styled.div`
  flex: 1;
  margin-bottom: 3em;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ChartMessage = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444444;
`;

export const BodyContentV2 = styled(LoadingWrapperV2)`
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
